import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        main: {
            w: '100%',

            '.swiper-button-disabled': {
                display: 'none',
            },
        },
        container: {
            maxW: {xl: remCalc(1400), base: '100%'},
            mx: 'auto',
            mb: {base: 0, md: remCalc(16), lg: remCalc(40)},
            px: {base: remCalc(16), md: remCalc(24), xl: 0},
            textAlign: 'center',
            justifyContent: 'center',
        },
        sortingSwiper: {
            mb: remCalc(24),
        },
        chevronIcon: {
            w: 'iconsSize.medium',
            h: 'iconsSize.medium',
            position: 'absolute',
            backgroundColor: 'background.default',
            borderWidth: remCalc(1),
            borderColor: 'border.dark',
            borderRadius: '50%',
            top: remCalc(166),
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            zIndex: '10',
        },
        heading: {
            py: {base: remCalc(16), md: remCalc(40)},
            w: '100%',
        },
        bodycopy: {
            w: '100%',
            textStyle: 'body-large',
            pb: remCalc(40),
        },
        tilecontainer: {
            w: '100%',
            gap: {base: 0, md: remCalc(16), lg: remCalc(24)},
            pb: remCalc(24),
        },
        tile: {
            w: '100%',
            gap: remCalc(24),
            flexDirection: 'column',
            alignItems: 'center',
        },
        tileimage: {
            w: '100%',
            maxW: {base: remCalc(332), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
            minW: {base: remCalc(332), md: 'unset'},
            alignSelf: 'center',
        },
        ctacontainer: {
            w: '100%',
            gap: {base: remCalc(16), md: remCalc(24)},
        },
        cta: {
            w: {base: remCalc(228), md: remCalc(168), lg: remCalc(226), xl: remCalc(332)},
            textDecoration: 'none !important',
        },
    },
}
